import { render, staticRenderFns } from "./CreateBatchRecord.vue?vue&type=template&id=8a766124&scoped=true&"
import script from "./CreateBatchRecord.vue?vue&type=script&lang=js&"
export * from "./CreateBatchRecord.vue?vue&type=script&lang=js&"
import style0 from "./CreateBatchRecord.vue?vue&type=style&index=0&id=8a766124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a766124",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/acarmichael/Desktop/DEV/BOSS40-FrontEnd/boss-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VCard,VDatePicker,VFlex,VForm,VIcon,VLayout,VMenu,VTextField})
